import { CircleXmark, TriangleExclamation } from "@gravity-ui/icons";
import { Button, Flex, Icon, Text } from "@gravity-ui/uikit";

import { useProductPriceStatusTranslate } from "./hooks";
import css from "./ProductPriceStatus.module.scss";

interface ProductPriceStatusProps {
  kind: "error" | "empty";
  platformLabel: string | null;
  onRetry: () => void;
}

export const ProductPriceStatus = ({
  kind,
  platformLabel,
  onRetry,
}: ProductPriceStatusProps) => {
  const translations = useProductPriceStatusTranslate();
  const platform = platformLabel ?? translations.this_platform;

  return (
    <Flex
      direction="column"
      gap="3"
      alignItems="flex-start"
      className={css.status}
    >
      <Flex gap="2" alignItems="center">
        <Icon
          data={kind === "error" ? TriangleExclamation : CircleXmark}
          size={18}
        />
        <Text variant="subheader-2">
          {kind === "error"
            ? translations.load_failed(platform)
            : translations.no_prices(platform)}
        </Text>
      </Flex>

      <Text variant="body-2" color="secondary">
        {kind === "error"
          ? translations.load_failed_hint
          : translations.no_prices_hint}
      </Text>

      {kind === "error" && (
        <Button size="m" onClick={onRetry}>
          {translations.retry}
        </Button>
      )}
    </Flex>
  );
};
